import { Component, Input, OnInit, inject } from '@angular/core';
import { NbDialogRef, NbCardModule, NbButtonModule, NbCheckboxModule } from '@nebular/theme';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-dialog-alert',
  standalone: true,
  imports: [CommonModule, NbCardModule, NbButtonModule, NbCheckboxModule, FormsModule],
  template: `
    <nb-card class="dialog-alert">
      <nb-card-header>{{ title }}</nb-card-header>
      <nb-card-body>
        <p>{{ message }}</p>
      </nb-card-body>
      <nb-card-footer class="footer-actions">
        <button nbButton status="basic" size="medium" type="button" (click)="cancelar()">Cancelar</button>
        <button nbButton status="primary" size="medium" type="button" (click)="confirmar()">OK</button>
      </nb-card-footer>
    </nb-card>
  `,
})
export class DialogAlertComponent implements OnInit {
  @Input() title!: string;
  @Input() message!: string;
  @Input() mostrarConfirmacao: boolean = false; 
  @Input() msgConfirmacao: string = 'Confirmar';

  ref = inject(NbDialogRef<DialogAlertComponent>);

  ngOnInit(): void {

  }

  confirmar() {
    this.ref.close(true);  
  }

  cancelar() {
    this.ref.close(false);  
  }
}
